import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { ReactElement, Ref, forwardRef } from 'react';
import ReactJson from 'react-json-view';
import { Download } from '@mui/icons-material';

const Transition = forwardRef(function Transition(props: TransitionProps & { children: ReactElement }, ref: Ref<unknown>) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export type JsonViewerFullScreenDialogType = {
  open: boolean,
  handleClose: () => void,
  json: any
}

export default function JsonViewerFullScreenDialog({ open, handleClose, json }: JsonViewerFullScreenDialogType) {

  const onClickDownloadData = () => downloadData(JSON.stringify(formatter()), "dados.json", "text/plain");

	const downloadData = (content: any, fileName: string, contentType: string) => {
		const a = document.createElement("a");
		const file = new Blob([content], { type: contentType });
		a.href = URL.createObjectURL(file);
		a.download = fileName;
		a.click();
	}

  const formatter = () => ({
    userName: json.userName,
    userId: json.userId,
    name: json.name,
    id: json.id,
    paymentId: json.paymentId,
    paymentStatus: json.paymentStatus,
    urbia_label: json.urbia_label,
    image: json.image,
    housesCon: json.housesCon,
    controledLot: json.controledLot,
    closedCon: json.closedCon,
    openLot: json.openLot,
    other: json.other,
    enterprise_standard: json.dataHelper.enterprise_standard,
    gleba_size_ha: json.area? json.area.split(' ')[0] : json.dataHelper.gleba_size_ha? json.dataHelper.gleba_size_ha : '',
    description: json.description,
    legislation_info: json.dataHelper.legislation_info,
    createdAt: json.createdAt,
    kmzFileLink: json.kmzFileLink,
    selectedServices: json?.selectedOptions? Object.keys(json.selectedOptions).filter(key => json.selectedOptions[key] === true) : [],
    dataHelper: {
      resLot_front_size: json.dataHelper.resLot_front_size,
      resLot_min_area: json.dataHelper.resLot_min_area,
      resLot_lot_depth: json.dataHelper.resLot_lot_depth,
      resCorner_front_size: json.dataHelper.resCorner_front_size,
      resCorner_lot_depth: json.dataHelper.resCorner_lot_deptha,
      resCorner_min_area: json.dataHelper.resCorner_min_area,
      commercialLot_front_size: json.dataHelper.commercialLot_front_size,
      commercialLot_min_area: json.dataHelper.commercialLot_min_area,
      commercialLot_lot_depth: json.dataHelper.commercialLot_lot_depth,
      commercialCorner_front_size: json.dataHelper.commercialCorner_front_size,
      commercialCorner_min_area: json.dataHelper.commercialCorner_min_area,
      commercialCorner_lot_depth: json.dataHelper.commercialCorner_lot_depth,
      block_length: json.dataHelper.block_length,
      donate_appAv: json.dataHelper.donate_appAv,
      donate_green_area: json.dataHelper.donate_green_area,
      donate_institutional_area: json.dataHelper.donate_institutional_area,
      donate_other: json.dataHelper.donate_other,
      local_range: json.dataHelper.local_range,
      local_sidewalk: json.dataHelper.local_sidewalk,
      collector_range: json.dataHelper.collector_range,
      collector_sidewalk: json.dataHelper.collector_sidewalk,
      culdesac_diameter: json.dataHelper.arterial_range,
      aquisition: json.dataHelper.aquisition,
      glebaValue: json.dataHelper.glebaValue,
      litorianReg: json.dataHelper.litorianReg,
      efluentTreatment: json.dataHelper.efluentTreatment,
      pavimentation: json.dataHelper.pavimentation,
      predomTopo: json.dataHelper.predomTopo,
      predomGroud: json.dataHelper.predomGroud,
      rainRelease: json.dataHelper.rainRelease,
      architecture: json.dataHelper.architecture,
      architecture_area: json.dataHelper.architecture_area,
      reservatory: json.dataHelper.reservatory,
      permut: json.dataHelper.permut,
      vgvFees: json.dataHelper.vgvFees,
      brokerage: json.dataHelper.brokerage,
      sellPriceMeter: json.dataHelper.sellPriceMeter,
      otherInfos: json.dataHelper.otherInfos,
      otherFilesLink: json.dataHelper.otherFilesLink,
    }
  });
  
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Dados
          </Typography>
          <Button startIcon={<Download />} color='inherit' onClick={onClickDownloadData}>
            BAIXAR JSON
          </Button>
        </Toolbar>
      </AppBar>
      <ReactJson src={formatter()} theme="monokai" />
    </Dialog>
  );
}